import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'
import { useI18n } from 'vue-i18n-composable'
import CustomDialogActionButtonsComponent from '@/components/Dialog/CustomDialog/CustomDialogActionButtonsComponent.vue'
import CustomDialogHeaderComponent from '@/components/Dialog/CustomDialog/CustomDialogHeaderComponent.vue'
import { ModuleNamespaces } from '@/store/types/storeGlobalTypes'
import store from '@/store/store'
import LfErrorListComponent from '@/components/forms/message/LfErrorListComponent.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'ErrorListDialogComponent',
  props: {
    componentProps: { type: Object, required: true }
  },
  setup(__props: any) {

const props = __props as {
  componentProps: { errors: string[], title: string, description: string }
};

const { t } = useI18n()



const texts = {
  title: props.componentProps.title || t('components.dialog.maintenance_errors_list_title_default').toString(),
  body: props.componentProps.description || t('components.dialog.maintenance_errors_list_description_default').toString(),
  primaryButtonText: t('action_buttons.accept').toString()
}

const icon = computed(() => {
  return require('@/assets/images/svg/Track-Right.svg')
})

const closeDialog = () => {
  store.dispatch(`${ModuleNamespaces.DIALOG}/closeCustomDialog`)
}


return { __sfc: true,t, props, texts, icon, closeDialog, CustomDialogActionButtonsComponent, CustomDialogHeaderComponent, LfErrorListComponent }
}

})